module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-35ba08d5cfa9c628dfcc567ad8f19d47.webp";